import { useUserIdQuery } from "@shared/data/queries/UserIdQuery/UserId.query";
import { OAuthLandingPage } from "@unauthenticated/oauth/components/OAuthOnboardingFlow/OAuthLandingStep/OAuthLandingPage/OAuthLandingPage";
import { SkeletonOAuthLandingPage } from "@unauthenticated/oauth/components/OAuthOnboardingFlow/OAuthLandingStep/OAuthLandingPage/SkeletonOAuthLandingPage";

import { OAuthStep } from "../oauthStep";

interface Props {
  target?: string;
  ssoOrigin?: string;
  onUpdateCurrentStep: (step: OAuthStep) => void;
}

const OAuthLandingStep = ({ onUpdateCurrentStep, ssoOrigin, target }: Props) => {
  const { data: userQueryData, loading: userQueryLoading } = useUserIdQuery({
    fetchPolicy: "network-only",
  });

  if (userQueryLoading && !userQueryData) {
    return ssoOrigin || target ? null : <SkeletonOAuthLandingPage />;
  }

  if (userQueryData?.viewer) {
    if (ssoOrigin === "signin") {
      onUpdateCurrentStep(OAuthStep.AUTHORIZATION);
    } else if (ssoOrigin === "signup") {
      onUpdateCurrentStep(OAuthStep.CERTIFICATION);
    }
  } else if (!userQueryLoading) {
    if (ssoOrigin === "signin" || target === "signin") {
      onUpdateCurrentStep(OAuthStep.SIGN_IN);
    } else if (ssoOrigin === "signup") {
      onUpdateCurrentStep(OAuthStep.SIGN_UP);
    }
  }

  return <OAuthLandingPage onUpdateCurrentStep={onUpdateCurrentStep} />;
};

export { OAuthLandingStep };
